import { Divider, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'
import {
  ReferralBaseInfo,
  ReferralById,
} from '../../types/patientReferrals.types'
import { ReferralPatientDetails } from './ReferralPatientDetails'
import { Loading } from '../../../../../common/components/Loading'
import { ReferralDoctorDetails } from './ReferralDoctorDetails'

interface ReferralDetailsViewStepProps {
  referralBaseInfo: ReferralBaseInfo
  referral: ReferralById
  loading: boolean
}
const ReferralDetailsViewStep: React.FC<ReferralDetailsViewStepProps> = ({
  referralBaseInfo,
  referral,
  loading,
}) => {
  const { t } = useTranslation()

  if (loading) {
    return <Loading />
  }

  return (
    <Stack gap={2}>
      <Typography variant="body2">
        {t('doctor:referralDetails.subtitle')}
      </Typography>

      <ReferralPatientDetails referralBaseInfo={referralBaseInfo} />

      <Divider />

      <Grid container columnSpacing={2} rowSpacing={0}>
        <Grid item xs={6}>
          <BoxWithLabel label={t('doctor:referralDetails.logNumber')}>
            <Typography variant="h6">{referral.logNumber}</Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={12}>
          <BoxWithLabel label={t('doctor:referralDetails.disease')}>
            <Typography>{referral.description}</Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={6}>
          <BoxWithLabel label={t('doctor:referralDetails.expirationDate')}>
            <Typography variant="h6">
              {t('common:dateFormatted', {
                date: referral.expirationDate,
              })}
            </Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={12}>
          <BoxWithLabel label={t('doctor:referralDetails.profession')}>
            <Typography variant="h6">
              {referral.profession ? referral.profession?.name : '-'}
            </Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={3}>
          <BoxWithLabel label={t('doctor:referralDetails.place')}>
            <Typography variant="h6">{referral.createdAtPlace}</Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={4}>
          <BoxWithLabel label={t('doctor:referralDetails.date')}>
            <Typography variant="h6">
              {t('common:dateFormatted', {
                date: referral.createdAtDate,
              })}
            </Typography>
          </BoxWithLabel>
        </Grid>

        <Grid item xs={5}>
          <ReferralDoctorDetails referralBaseInfo={referralBaseInfo} />
        </Grid>
      </Grid>
    </Stack>
  )
}

export { ReferralDetailsViewStep }
